import { z } from 'zod';

export const NewRiskProfileSchemaStep0 = z.object({
	name: z.string().min(1),
	description: z.string().min(1),
});

export const NewRiskExpositionAreaSchemaStep0 = z.object({
	name: z.string().min(1),
	description: z.string().min(1),
	address: z.string().min(1),
});

export const NewRiskSchemaStep1 = z.object({
	associatedRisk: z.array(z.string()).min(1),
});
